import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_170_branch_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Add Branch",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            // {
            //     componentType: LayoutTypes.GROUP,
            //     style: {
            //         direction: FlexDirection.ROW,
            //         padding: 10,
            //     },
            //     childComponents: [
            //         {
            //             componentType: ComponentType.BUTTON,
            //             Label: "Back",
            //             style: {
            //                 backgroundColor: "#1f2937",
            //                 textColor: "#ffffff",
            //                 padding: 8,
            //                 borderRadius: 4,
            //             },
            //             onPressAction: "navigate_modulev1/branch_summary",
            //         },
            //     ],
            // },
            {
                componentType: LayoutTypes.FORM,
                Name: "branch_add",
                TableName: "branches",
                DisplayName: "Branches",
                columnNumber: "m1 t1 w3",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                childComponents: [
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_name",
                        label: "Name",
                        placeholder: "Enter branch name",
                        required: true,
                        Json_Attribute: "name",
                        IsVerticalView: true,
                    },
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_mobile",
                        label: "Mobile",
                        placeholder: "Enter mobile number",
                        required: true,
                        Json_Attribute: "mobile",
                        IsVerticalView: true,
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            direction: FlexDirection.ROW,
                            gap: 10,
                            paddingTop: 20,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                Label: "Submit",
                                onPressAction: "save",
                                ActionType: "Add", // Assuming Add since it's branch_add
                                ScreenId: "170",
                                style: {
                                    backgroundColor: "#3b82f6",
                                    textColor: "#ffffff",
                                    padding: 12,
                                    borderRadius: 8,
                                },
                            },
                            // {
                            //     componentType: ComponentType.BUTTON,
                            //     Label: "Cancel",
                            //     onPressAction: "navigate_modulev1/branch_summary",
                            //     style: {
                            //         backgroundColor: "#6b7280",
                            //         textColor: "#ffffff",
                            //         padding: 12,
                            //         borderRadius: 8,
                            //     },
                            // },
                        ],
                    },
                ],
            },
        ],
    },
];
